import {
  convertZonetoUTCEnd,
  convertZonetoUTCStart,
} from "../../Helper/DatePicker/DateConverter";
import moment from "moment";

export const calculateGranularity = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return "Weekly";
  }
  const daysDiff = moment(endDate).diff(moment(startDate), "days") + 1; // Plus 1 to make both inclusive
  if (daysDiff <= 14) {
    return "Daily";
  } else if (daysDiff > 60) {
    return "Monthly";
  }
  return "Weekly";
};

export const getDateRangeFromTimePeriod = (timePeriod) => {
  // Return null if timePeriod is not provided
  if (!timePeriod) {
    return null;
  }

  const now = new Date();
  let startDate = new Date();
  let endDate = new Date();

  switch (timePeriod) {
    case "Today":
      startDate.setDate(now.getDate());
      endDate.setDate(now.getDate());
      break;
    case "Yesterday":
      startDate.setDate(now.getDate() - 1);
      endDate.setDate(now.getDate() - 1);
      break;
    case "Last 7 days":
      startDate.setDate(now.getDate() - 7);
      break;
    case "Last 30 days":
      startDate.setDate(now.getDate() - 30);
      break;
    case "Last 45 days":
      startDate.setDate(now.getDate() - 45);
      break;
    case "Last 90 days":
      startDate.setDate(now.getDate() - 90);
      break;
    default:
      // Return null for unrecognized time periods
      return null;
  }

  // Format dates as "YYYY-MM-DD" for timezone conversion
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Convert user timezone dates to UTC with proper start/end of day handling
  const startDateStr = formatDate(startDate);
  const endDateStr = formatDate(endDate);

  return {
    resolvedAt: JSON.stringify({
      startDateUTC: convertZonetoUTCStart(startDateStr),
      endDateUTC: convertZonetoUTCEnd(endDateStr),
    }),
  };
};

